import {
  RESULTING_FN_TYPE_ALL,
  RESULTING_FN_TYPE_GET,
  RESULTING_FN_TYPE_PUT,
  RESULTING_FN_TYPE_DELETE,
  RESULTING_FN_TYPE_POST,
  RESULTING_FN_TYPE_LOADING,
  RESULTING_FN_TYPE_ERROR,
} from '../../actions/types';

const initialState = {
  resultingFunctionType: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case RESULTING_FN_TYPE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case RESULTING_FN_TYPE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case RESULTING_FN_TYPE_POST:
      return { isLoading: false, isCompleted: true };
    case RESULTING_FN_TYPE_PUT:
      return { isLoading: false, isCompleted: true };
    case RESULTING_FN_TYPE_DELETE:
      return { isLoading: false, isCompleted: true };
    case RESULTING_FN_TYPE_LOADING:
      return { isLoading: true, isCompleted: true };
    case RESULTING_FN_TYPE_ERROR:
      return { isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
